import { DELETE_ATTACHMENT_TEMPLATES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = { success: boolean; error?: string };

export default (id: string): Promise<Res> => {
    return fetchWithRefresh(DELETE_ATTACHMENT_TEMPLATES, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify({ id }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to DELETE Attachment Template: ' + res.status);
        }
    });
};
